import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import { useIsMobileScreen } from '@/hooks/useMedia';

export const useTruncatedName = (name: string) => {
  const { isMobile, isTablet } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({
    defaultMatches: isMobile || isTablet,
  });

  const truncatedName = name.substring(0, isMobileScreen ? 18 : name.length);

  return `${truncatedName}${truncatedName === name ? '' : '...'}`;
};
